import {Component, EventEmitter} from '@angular/core';
import {CommonService} from "./common.service";
import {Router} from "@angular/router";
import {Location} from '@angular/common';
import {MaterializeAction} from 'angular2-materialize/dist';
//import {EventEmitter} from "events";
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})
export class AppComponent {
    is_loggedin: Boolean = false;
    modalActions = new EventEmitter<string|MaterializeAction>();
    title = 'app';
    serverMessage = {'error': '', 'success': ''}
    contactInfo = {'email': '', 'message': ''};
    rowData = {
        'datadim001': '',
        'datadim002': '',
        'datadim003': '',
        'datadim004': '',
        'datadim005': '',
        'datadim006': '',
        'lang': ''
    };
    private submitted: boolean = false;
    private logo;

    constructor(public commonService: CommonService, private router: Router, private location: Location) {
        var token = localStorage.getItem('token');
        var email = localStorage.getItem('email');
        if (!token) {
            this.router.navigate(['login']);
        } else {
            this.is_loggedin = false;
            this.is_loggedin = true;

            let data = {
                'client': 1,
                'token': localStorage.getItem('token')
            }
            let url = 'http://node.illumine.info/zl61s7';
            this.commonService.post_data(data, url).subscribe(
                response => {
                    //noinspection TypeScriptUnresolvedVariable
                    if (response.status == 'success') {
                        this.logo = response.data[0].logo;
                        console.log(this.logo);
                    } else if (response.status == 'error') {
                        localStorage.setItem('token', "");
                        localStorage.setItem('email', "");
                        this.router.navigate(['login']);
                    }
                }, error => {
                    console.log(error);
                }
            );

            this.router.navigate(['dashboard']);
        }
    }

    ngOnInit() {
        let url = 'http://node.illumine.info/WrR10S';
        this.commonService.get_data(url).subscribe(
            response => {
                this.rowData['datadim001'] = response['A'][0]['B'][0];
                this.rowData['datadim002'] = response['A'][0]['B'][1];
                this.rowData['datadim003'] = response['A'][0]['B'][2];
                this.rowData['datadim004'] = response['A'][1]['B'][0];
                this.rowData['datadim005'] = response['A'][1]['B'][1];
                this.rowData['datadim006'] = response['A'][1]['B'][2];
                this.rowData['lang'] = response['Language'];
                this.commonService.setMasterApi(this.rowData);
            }, error => {
                console.log(error);
            }
        );
    }

    signOut() {
        localStorage.setItem('token', "");
        localStorage.setItem('email', "");
        this.router.navigate(['login']);
        this.is_loggedin = false;
    }

    openContactUs() {
        this.modalActions.emit({action: "modal", params: ['open']});
    }

    closeModal() {
        this.modalActions.emit({action: "modal", params: ['close']});
    }

    /**
     *
     * @param contactInfo
     * @param is_valid
     * @returns {boolean}
     */
    contactus(contactInfo, is_valid) {

        console.log(is_valid);
        if (!is_valid) {
            this.submitted = true;
            return false
        }
        contactInfo['token'] = localStorage.getItem('token');
        let url = 'http://node.illumine.info/ElPOmD';
        this.commonService.post_data(contactInfo, url).subscribe(
            response => {
                console.log(response);
                //noinspection TypeScriptUnresolvedVariable
                if (response.status == 'success') {

                } else {
                    //noinspection TypeScriptUnresolvedVariable
                    this.serverMessage.error = response.message
                }
            }, error => {
                console.log(error);
            }
        );

    }
}



// WEBPACK FOOTER //
// /var/www/illumine/desktop/src/app/app.component.ts